import React, { Component } from "react";

class WizardPager extends Component {
  render() {
    const { updateField, stepIndexPages, wizardStepIndex } = this.props;

    return (
      <div className="pagination">
        {stepIndexPages.map((stepIndex, i) => (
          <a
            key={`${i}`}
            className={wizardStepIndex === stepIndex ? "active" : ""}
            onClick={() => updateField("gotoStepIndex", stepIndex)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                updateField("gotoStepIndex", stepIndex);
              }
            }}
            role="button"
            tabIndex={0}
          >
            {i + 1}
          </a>
        ))}
      </div>
    );
  }
}

export default WizardPager;



// WEBPACK FOOTER //
// ./src/components/wizard-pager.js